import { render, staticRenderFns } from "./PaymentRejecteDowngrade.vue?vue&type=template&id=72b67544&scoped=true&"
import script from "./PaymentRejecteDowngrade.vue?vue&type=script&lang=js&"
export * from "./PaymentRejecteDowngrade.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRejecteDowngrade.vue?vue&type=style&index=0&id=72b67544&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b67544",
  null
  
)

export default component.exports